import { PillarCard } from "./PillarCard";

export function QuemSomosSection() {
  return (
    <div id="quem-somos" className="page-section flex flex-col grow bg-fundo">
      <section className="bg-fundo relative pt-nav pb-24 grow">
        <div className="absolute top-0 right-0 w-64 h-64 bg-dourado opacity-5 rounded-bl-[100px] pointer-events-none"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            {/* Texto da História */}
            <div>
              <h2 className="text-sm text-dourado font-bold tracking-widest uppercase mb-2">
                A Fundação
              </h2>
              <h3 className="text-4xl sm:text-5xl font-titulo font-bold text-petroleo mb-8">
                Nossa Origem
              </h3>
              <p className="text-base sm:text-lg leading-relaxed mb-6 text-gray-700 text-justify">
                Fundada em <strong>09 de dezembro de 2025</strong> no Oriente de
                Florianópolis/SC, a Loja Hórus Nº 147 nasceu do desejo
                inabalável de seus irmãos fundadores de erguer um templo
                inteiramente focado na investigação da Verdade, no culto da
                Moral e na prática profunda da Solidariedade.
              </p>
              <p className="text-base sm:text-lg leading-relaxed mb-8 text-gray-700 text-justify">
                A escolha do nome{" "}
                <strong className="text-petroleo">Hórus</strong> é uma
                reverência direta à rica simbologia do "Olho que tudo Vê",
                representando a onisciência e onipresença do Grande Arquiteto do
                Universo. Ele nos serve como um lembrete maçônico constante de
                que a nossa jornada de aperfeiçoamento espiritual está sempre
                sob observação divina.
              </p>

              {/* Novo Bloco: Significado do Número 147 */}
              <div className="bg-white p-6 rounded-xl border-l-4 border-petroleo shadow-sm mb-8">
                <h4 className="font-titulo text-lg sm:text-xl text-petroleo font-bold mb-3 flex items-center">
                  <i className="fa-solid fa-hashtag text-dourado mr-2"></i> O
                  Número 147
                </h4>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed text-justify">
                  O número que adorna o nosso título distintivo não é obra do
                  acaso. O "147" representa o nosso registo de filiação e
                  reconhecimento regular sob os auspícios da{" "}
                  <strong>M.·.R.·.G.·.L.·.S.·.C.·.</strong> (Grande Loja de
                  Santa Catarina). Ele marca de forma perene a nossa identidade
                  única, o nosso lugar na linha temporal histórica e a nossa
                  regularidade maçônica perante as potências mundiais.
                </p>
              </div>

              <div className="border-l-4 border-dourado pl-6 py-4 italic text-sm sm:text-base text-gray-600 bg-white shadow-md rounded relative">
                <i className="fa-solid fa-quote-left absolute top-2 left-2 text-gray-200 text-2xl opacity-50"></i>
                "Tenha coragem em todas as circunstâncias da vida, por pior que
                lhe pareçam as dificuldades. Tenha certeza de que pode
                superá-las com a força que provém de seu íntimo."
              </div>
            </div>

            {/* Cards de Pilares */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 relative">
              <div className="absolute inset-0 bg-petroleo opacity-5 transform scale-105 rounded-xl pointer-events-none -rotate-2"></div>

              <PillarCard
                icon="fa-dove"
                title="Liberdade"
                description="Independência de espírito e ausência de dogmas dogmáticos."
                theme="petroleo"
              />

              <PillarCard
                icon="fa-scale-balanced"
                title="Igualdade"
                description="A certeza de que todos somos filhos do mesmo Criador."
                theme="white-dourado"
                offsetY={true}
              />

              <PillarCard
                icon="fa-handshake-angle"
                title="Fraternidade"
                description="A prática mútua da solidariedade e do amor fraterno."
                theme="white-petroleo"
              />

              <PillarCard
                icon="fa-book-open"
                title="Sabedoria"
                description="O progresso intelectual e a incessante busca da verdade."
                theme="dourado"
                offsetY={true}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
export default QuemSomosSection;
